import axios from "axios";
import router from "../src/router";
import { Message, Alert } from "element-ui";
const service = axios.create({
  baseURL: "https://partnersocial.intel.cn/api", // 正式环境
  // baseURL: 'https://partnersocialtest.intel.cn/apiTest', // 测试环境
  // baseURL: 'http://54.223.188.166:8084/reportTest', // 测试环境2
  // baseURL: '/api', // 开发环境
  timeout: 30000, // 超时时间
  headers: {
    "Content-Type": "application/json"
  }
});
// let token = window.localStorage.getItem('token')
// service.defaults.headers.common['Authorization'] = token;
// service.defaults.headers.post['Content-Type'] = 'application/json;charset=UTF-8';//配置请求头
service.interceptors.request.use(
  config => {
    let token = window.localStorage.getItem("token")
      ? window.localStorage.getItem("token")
      : "Bearer FRONT_PC_cd166098-7870-4f8a-a6d1-fa90ea53cb2c_17be029acc79d33d35c48eb042505a97_1557456250286";
    let { headers } = config;
    config.headers["Authorization"] = window.localStorage.getItem("token")
      ? window.localStorage.getItem("token")
      : "Bearer FRONT_PC_cd166098-7870-4f8a-a6d1-fa90ea53cb2c_17be029acc79d33d35c48eb042505a97_1557456250286";
    return config;
  },
  error => {}
);
service.interceptors.response.use(
  response => {
    if (response.data.code === 301) {
      Message({
        message: "登录过期，或服务器重启，请重新登录",
        type: "error"
      });
      setTimeout(() => {
        localStorage.clear();
        router.push("/");
      }, 2000);
    } else if (response.data.msg == "token失效，请输入有效的token") {
      Message({
        message: response.data.msg,
        type: "warning"
      });
      setTimeout(() => {
        localStorage.clear();
        router.push("/");
      }, 2000);
    }
    return response;
  },
  error => {
    Message({
      message: "网络连接错误",
      type: "error",
      duration: 5 * 1000
    });

    // 处理响应失败
    return Promise.reject(error);
  }
);

export default service;



//////////////////
// WEBPACK FOOTER
// ./api/fetch.js
// module id = null
// module chunks = 